// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"580":"0c8dff8d","616":"a4bf7521","826":"26d17cfb","962":"8a0bd0dd"}[chunkId] + ".chunk.css";
};